/** api-notes.ts — 현장 노트(배운 점 · 서비스 아이디어) API · backend/routes/tm-field-notes.js (2026-11-01) */
const BASE = '/api/tm/field-notes';

export type NoteKind = 'learn' | 'idea';
export type NoteStatus = 'memo' | 'review' | 'dev' | 'done' | 'hold';
export type NoteTarget = '' | 'fphub' | 'roum' | 'report' | 'lecture' | 'etc';

export interface FieldNote {
  id: string; kind: NoteKind; title: string; body: string; scene: string;
  target: NoteTarget; status: NoteStatus; done_note: string; source_person: string; pinned: boolean;
  consultation_id: string | null; company_id: string | null; fp_id: string | null;
  company_name?: string | null; fp_name?: string | null; consult_date?: string | null;
  created_by_name: string; created_at: string; updated_at: string;
}
export interface NoteCounts { total: number; status: Partial<Record<NoteStatus, number>>; target: Partial<Record<string, number>> }

export const STATUS_LABEL: Record<NoteStatus, string> = { memo: '적어 둠', review: '검토', dev: '만드는 중', done: '반영함', hold: '보류' };
export const TARGET_LABEL: Record<Exclude<NoteTarget, ''>, string> = { fphub: 'fphub', roum: '로움', report: '리포트', lecture: '강의', etc: '기타' };

function token(): string { return localStorage.getItem('token') || ''; }
async function req<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(BASE + path, {
    method, cache: 'no-store',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() },
    body: body !== undefined && method !== 'GET' ? JSON.stringify(body) : undefined,
  });
  const j = await res.json().catch(() => null) as { success?: boolean; data?: T; error?: string } | null;
  if (!res.ok || !j || !j.success) throw new Error((j && j.error) || '저장하지 못했어요 (' + res.status + ')');
  return j.data as T;
}

export function listNotes(f: { kind: NoteKind; q?: string; status?: NoteStatus | ''; target?: NoteTarget }): Promise<{ list: FieldNote[]; counts: NoteCounts }> {
  const p = new URLSearchParams({ kind: f.kind });
  if (f.q) p.set('q', f.q);
  if (f.status) p.set('status', f.status);
  if (f.target) p.set('target', f.target);
  return req('GET', '/?' + p.toString());
}
export const createNote = (b: Partial<FieldNote>): Promise<FieldNote> => req('POST', '/', b);
export const updateNote = (id: string, b: Partial<FieldNote>): Promise<FieldNote> => req('PUT', '/' + id, b);
export const deleteNote = (id: string): Promise<{ id: string }> => req('DELETE', '/' + id);
/** 상담 결과의 「내가 배운 점」 — 상담 하나에 한 줄 · 빈 글이면 지움 */
export const getConsultLearn = (cid: string): Promise<FieldNote | null> => req('GET', '/consult/' + cid);
export const saveConsultLearn = (cid: string, body: string): Promise<FieldNote | null> => req('PUT', '/consult/' + cid, { body });

/** 목록 한 줄 제목 — 제목이 없으면 본문 첫 줄 */
export const noteTitle = (n: Pick<FieldNote, 'title' | 'body' | 'scene'>): string =>
  (n.title || '').trim() || String(n.body || n.scene || '').split('\n').map((s) => s.trim()).find(Boolean) || '(내용 없음)';
